import React, {memo} from 'react';
import Link from 'next/link';
import Container from '@/components/atoms/Container';
import styles from './Footer.module.scss';

const Footer = () => {
    return (
        <div className={styles.footer}>
            <Container>
                <div className={styles.inner}>
                    <p className={`font-regular-text ${styles.text}`}>
                        Copyright © 2026, Debut Infotech. All rights reserved. |{' '}
                        <Link href="/privacy-policy" className={`font-regular-text ${styles.privacyLink}`}>
                            Privacy Policy
                        </Link>
                    </p>
                </div>
            </Container>
        </div>
    );
};
export default memo(Footer);
